import { searchKeywordResult } from 'interface'
const ResultBox = ({ result }: { result: searchKeywordResult }) => {
  return (
    <div className="row display_search_result">
      <div className="col-12 col-lg-3 col-md-3  col-sm-3">
        <div>
          <p className="title-left">สถานะ</p>
          <p className="title-secm">:</p>
        </div>
      </div>
      <div className="col-12 col-lg-9 col-md-9 col-sm-9">
        <p>{result.cncnm ?? ''}</p>
      </div>

      <div className="col-12 col-lg-3 col-md-3  col-sm-3">
        <div>
          <p className="title-left">ประเภทผลิตภัณฑ์</p>
          <p className="title-secm">:</p>
        </div>
      </div>
      <div className="col-12 col-lg-9 col-md-9 col-sm-9">
        <p>{result.typepro ?? ''}</p>
      </div>

      <div className="col-12 col-lg-3 col-md-3  col-sm-3">
        <div>
          <p className="title-left">ใบสำคัญ/เลขที่อนุญาต</p>
          <p className="title-secm">:</p>
        </div>
      </div>
      <div className="col-12 col-lg-9 col-md-9 col-sm-9">
        <p>{result.lcnno ?? ''}</p>
      </div>

      <div className="col-12 col-lg-3 col-md-3  col-sm-3">
        <div>
          <p className="title-left">ชื่อผลิตภัณฑ์ (TH)</p>
          <p className="title-secm">:</p>
        </div>
      </div>
      <div className="col-12 col-lg-9 col-md-9 col-sm-9">
        <p>{result.productha ?? ''}</p>
      </div>

      <div className="col-12 col-lg-3 col-md-3  col-sm-3">
        <div>
          <p className="title-left">ชื่อผลิตภัณฑ์ (EN)</p>
          <p className="title-secm">:</p>
        </div>
      </div>
      <div className="col-12 col-lg-9 col-md-9 col-sm-9">
        <p>{result.produceng ?? ''}</p>
      </div>
      <div className="col-12 col-lg-3 col-md-3  col-sm-3">
        <div>
          <p className="title-left">ชื่อผู้รับอนุญาต</p>
          <p className="title-secm">:</p>
        </div>
      </div>
      <div className="col-12 col-lg-9 col-md-9 col-sm-9">
        <p>{result.licen ?? ''}</p>
      </div>
      <div className="col-12 col-lg-3 col-md-3  col-sm-3">
        <div>
          <p className="title-left">สถานที่ผลิต</p>
          <p className="title-secm">:</p>
        </div>
      </div>
      <div className="col-12 col-lg-9 col-md-9 col-sm-9">
        <p>{result.thanm ?? ''}</p>
      </div>
      <div className="col-12 col-lg-3 col-md-3  col-sm-3">
        <div>
          <p className="title-left">ที่อยู่สถานที่ผลิต</p>
          <p className="title-secm">:</p>
        </div>
      </div>
      <div className="col-12 col-lg-9 col-md-9 col-sm-9">
        <p>{result.Addr ?? ''}</p>
      </div>
      <div className="col-12 col-lg-3 col-md-3  col-sm-3">
        <div>
          <p className="title-left">Newcode</p>
          <p className="title-secm">:</p>
        </div>
      </div>
      <div className="col-12 col-lg-9 col-md-9 col-sm-9">
        <p>{result.NewCode ?? ''}</p>
      </div>
      <div className="col-12 col-lg-3 col-md-3  col-sm-3">
        <div>
          <p className="title-left">เพิ่มเติม</p>
          <p className="title-secm">:</p>
        </div>
      </div>
      <div className="col-12 col-lg-9 col-md-9 col-sm-9">
        <p>
          <a href={result.URLs} target="_blank" rel="noreferrer">
            ดูข้อมูล
          </a>
        </p>
      </div>

      <hr />
    </div>
  )
}

export default ResultBox
